import {NgModule} from '@angular/core';
import {APOLLO_OPTIONS} from 'apollo-angular';
import {ApolloLink, InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {AuthService} from './shared/services/auth.service';
import {environment} from '../environments/environment';
import {SentryLink} from 'apollo-link-sentry';

const uri = environment.host + 'graphql';

export function createApollo(
  httpLink: HttpLink,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  auth: AuthService,
): {cache: InMemoryCache; link: ApolloLink} {
  const http = httpLink.create({uri});

  return {
    link: ApolloLink.from([
      new SentryLink({
        setFingerprint: false,
        setTransaction: false,
        shouldHandleOperation: undefined,
        uri,
        attachBreadcrumbs: {
          includeError: true,
          includeQuery: true,
          includeVariables: true,
        },
      }),
      http,
    ]),
    cache: new InMemoryCache({
      addTypename: true,
    }),
  };
}

@NgModule({
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, AuthService],
    },
  ],
})
export class GraphQLModule {}
